module.exports = __webpack_public_path__ + "static/media/dinero_mobile.47792eda.svg";